<template>
  <div class="dimed wrap">
    <div class="layer layer--sm">
      <div class="layer__body">
        <div class="ft--xlg ft--bold">{{ text }}</div>
        <div class="ft--sm msg--margin">{{ message }} </div>
      </div>
      <div class="layer__button">
        <button class="btn btn--submit btn--xlg" @mouseup="$emit('setYes')">{{ $t('Modal.AlertConfirm.msg2') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'alertSuccess',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
    };
  },
  mounted() {},
  props: {
    text: String,
    message : String,
  },
  methods: {},
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style scoped>
.dimed {
  z-index: 35;
}
.msg--margin{
  margin-top : 5%;
  word-break : break-all;
}
</style>
